(() => {
  'use strict';
  if (window.AdriaAgeHelp) return;
  let opener = null, sourceShell = null, overflow = '', userDevice = null, restoreOnClose = true;
  const dialog = () => document.getElementById('ag-age-help-dialog');
  const media = window.matchMedia('(max-width: 767px)');
  function devices() {
    const value = userDevice || (media.matches ? 'phone' : 'computer');
    document.querySelectorAll('[data-ag-age-instructions]').forEach(root => {
      root.querySelectorAll('.ag-age-device-controls').forEach(n => n.hidden = false);
      root.querySelectorAll('[data-ag-device]').forEach(n => n.setAttribute('aria-pressed', String(n.dataset.agDevice === value)));
      root.querySelectorAll('[data-ag-device-panel]').forEach(n => n.hidden = n.dataset.agDevicePanel !== value);
    });
  }
  function fitFooter() {
    const d = dialog(), footer = d?.querySelector('footer');
    if (!d?.open || !footer) return;
    d.classList.toggle('ag-age-footer-inline', footer.getBoundingClientRect().height > (window.visualViewport?.height || window.innerHeight) / 4);
  }
  function close(restoreFocus = true) { const d = dialog(); restoreOnClose = restoreFocus; if (d?.open) d.close(); }
  function open(trigger) {
    const d = dialog();
    if (!d || d.open) return;
    opener = trigger;
    sourceShell = trigger.closest('[data-ag-cart-shell], #MinimogCartDrawer, #MinimogCart') || trigger.closest('form');
    overflow = document.body.style.overflow;
    d.showModal();
    document.body.style.overflow = 'hidden';
    trigger.setAttribute('aria-expanded','true');
    d.querySelector('.ag-age-dialog__scroll').scrollTop = 0;
    d.querySelector('h2').focus({preventScroll:true});
    devices(); fitFooter();
  }
  window.AdriaAgeHelp = {close, get sourceShell() { return sourceShell?.isConnected ? sourceShell : sourceShell?.id ? document.getElementById(sourceShell.id) : null; }};
  document.addEventListener('click', event => {
    const openButton = event.target.closest('[data-ag-help-open]');
    if (openButton && dialog()) { event.preventDefault(); open(openButton); return; }
    if (event.target.closest('[data-ag-help-close]')) { event.preventDefault(); close(); return; }
    const choice = event.target.closest('[data-ag-device]');
    if (choice) { userDevice = choice.dataset.agDevice; devices(); }
    if (event.target === dialog()) {
      const r = dialog().getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
    }
  });
  // The cart drawer has its own focus trap. Do not let its Escape/Tab handlers
  // intercept keyboard interaction with this top-layer modal.
  document.addEventListener('keydown', event => {
    const d = dialog(); if (!d?.open) return;
    if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); close(); return; }
    if (event.key !== 'Tab') return;
    event.stopImmediatePropagation();
    const nodes = [...d.querySelectorAll('a[href],button,summary,[tabindex="0"]')].filter(n => !n.disabled && !n.closest('[hidden]') && n.getClientRects().length);
    const first = nodes[0], last = nodes[nodes.length-1];
    if (!first) { event.preventDefault(); return; }
    if (event.shiftKey && (document.activeElement === first || !nodes.includes(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !nodes.includes(document.activeElement))) { event.preventDefault(); first.focus(); }
  },true);
  const d = dialog();
  if (d) {
    d.addEventListener('close', () => {
      document.body.style.overflow = overflow;
      opener?.setAttribute('aria-expanded','false');
      const target = opener?.isConnected ? opener : window.AdriaAgeHelp.sourceShell?.querySelector('[data-ag-help-open]');
      if (restoreOnClose) target?.focus({preventScroll:true});
    });
    new ResizeObserver(fitFooter).observe(d.querySelector('footer'));
  }
  // A lengthy summary must not squeeze the product list to zero on a phone.
  let observedFooter = null, cartObserver = null;
  function observeCartFooters() {
    const cart = document.getElementById('MinimogCartDrawer');
    const footer = cart?.querySelector('.m-cart-drawer__footer');
    if (footer === observedFooter) return;
    cartObserver?.disconnect(); observedFooter = footer;
    if (!footer) return;
    const fit = () => cart.classList.toggle('ag-age-long-summary', footer.getBoundingClientRect().height > (window.visualViewport?.height || innerHeight) * .55);
    cartObserver = new ResizeObserver(fit); cartObserver.observe(footer);
    fit();
  }
  new MutationObserver(observeCartFooters).observe(document.body,{childList:true,subtree:true});
  observeCartFooters();
  media.addEventListener('change',devices);
  window.addEventListener('resize',fitFooter);
  window.visualViewport?.addEventListener('resize',fitFooter);
  document.addEventListener('shopify:section:load',devices);
  devices();
})();
